import { render } from "./NavbarFilterGames.vue?vue&type=template&id=5b19849d&scoped=true"
import script from "./NavbarFilterGames.vue?vue&type=script&lang=js"
export * from "./NavbarFilterGames.vue?vue&type=script&lang=js"

import "./NavbarFilterGames.vue?vue&type=style&index=0&id=5b19849d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b19849d"]])

export default __exports__